/**
 * tdesign v0.3.1
 * (c) 2022 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-c445dc73.js';
import React__default from 'react';
import ReactDOM from 'react-dom';
import { defaultProps, ToastThemeListEnum } from './constant.js';
import Toast from './Toast.js';
import '../_chunks/dep-5cf1fbb1.js';
import '../_chunks/dep-f771ed13.js';
import '../_chunks/dep-fc32874d.js';
import '../_chunks/dep-b3e4e8ba.js';
import 'tdesign-icons-react';
import 'react-transition-group';
import 'classnames';
import '../overlay/index.js';
import '../overlay/Overlay.js';
import 'ahooks';
import '../_chunks/dep-d5ec015e.js';
import '../_chunks/dep-b31bb48b.js';
import '../_chunks/dep-ba137374.js';
import '../_chunks/dep-6b86f47a.js';
import '../_chunks/dep-9fe8d051.js';
import '../_util/withNativeProps.js';
import '../_chunks/dep-dadffb76.js';
import '../_chunks/dep-674c58f4.js';
import '../_chunks/dep-95834911.js';
import '../_chunks/dep-0e9724f2.js';
import '../_chunks/dep-cd7df551.js';
import '../_chunks/dep-41e2f4ed.js';
import '../_chunks/dep-818f0859.js';
import '../_chunks/dep-a4df350d.js';
import '../_chunks/dep-00b2fb56.js';
import '../_chunks/dep-6b8f1e75.js';
import '../_chunks/dep-aea8138c.js';
import '../_chunks/dep-d8b4285c.js';
import '../_util/withStopPropagation.js';
import '../_util/renderToContainer.js';
import '../_util/getContainer.js';
import '../_chunks/dep-3fecfff7.js';
import '../_util/canUseDom.js';
import '../_chunks/dep-c9dcffa1.js';
import '../_util/useLockScroll.js';
import '../_util/useTouch.js';
import '../_util/getScrollParent.js';
import '../_util/supportsPassive.js';
import '../_util/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_util/useShouldRender.js';
import '../_util/useInitialized.js';
import './style/css.js';
import './hooks/useMessageCssTransition.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var createToast = function createToast(props, theme) {
  var config = _objectSpread(_objectSpread({}, defaultProps), props);
  var el = document.createElement("div");
  document.body.appendChild(el);
  ReactDOM.render( /* @__PURE__ */React__default.createElement(Toast, _objectSpread({}, _objectSpread(_objectSpread({}, config), {}, {
    theme: theme,
    el: el
  }))), el);
  var destory = function destory() {
    document.body.removeChild(el);
  };
  return {
    destory: destory
  };
};
var methods = {
  createToast: createToast,
  success: function success(props) {
    return createToast(props, ToastThemeListEnum.success);
  },
  fail: function fail(props) {
    return createToast(props, ToastThemeListEnum.fail);
  },
  warning: function warning(props) {
    return createToast(props, ToastThemeListEnum.warning);
  },
  loading: function loading(props) {
    return createToast(props, ToastThemeListEnum.loading);
  }
};

export { methods as default };
//# sourceMappingURL=methods.js.map
